module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/WF-893ab8ccaaeb30991d3f675d1da1860e.png";